<div class="sbi-confirmation-dialog" *ngIf="data">
  <!-- Loading state -->
  <div class="loading-container" [hidden]="!isLoading">
    <p-progressSpinner
      [style]="{ width: '48px', height: '48px' }"
      strokeWidth="3"
      animationDuration="1.65s"
    ></p-progressSpinner>
    <span class="loading-text">{{
      data.loadingMessage || 'Procesando...'
    }}</span>
  </div>

  <!-- Confirmation state -->
  <div [hidden]="isLoading">
    <i
      *ngIf="!!!data?.hideCloseIcon"
      (click)="closeDialog()"
      class="pi pi-times close-icon"
    ></i>
    <h2 class="dialog-title">{{ data.title }}</h2>
    <div class="dialog-message" [innerHTML]="data.message"></div>
    <div class="dialog-actions">
      <button (click)="onConfirmClick()" class="button button-green">
        <i class="pi pi-check"></i>
        Confirmar
      </button>
    </div>
  </div>
</div>
